import { OnInit, ElementRef, Component } from '@angular/core';
import { ResourcesProvider } from 'src/app/providers/resources/resources.provider';
import { Resources } from 'src/app/models/resources';
import { Filters} from 'src/app/components/resources-filter/resources-filter.component';
import { ResourcesCssService } from './resources-css.service'
import { WindowService } from '../../services/window.service'
import { Base } from 'src/app/models/base-model';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ResourceStore } from 'src/app/stores/resources.store';

@Component({
    template: ''
})
export class ResourcesBase<T> implements OnInit {
    resources: Resources
    ngUnsubscribeResources = new Subject();

    filters: Filters = Filters.defaults()
    searchText: string = ''
    sortName: string = ''
    viewDisplayed: boolean = false

     onSearchTextChanged(text) {
        this.searchText = text
    }

    private listItemsChanged: boolean = true
    private listSearchText: string = ''
    private listSelectedFilterItems: string = ''
    private listSortName: string = ''
    private _listItems: T[]

    // This is what is bound to the UI
    get listItems(): T[] {
        if (this.viewDisplayed) {
            if (this.listItemsChanged ||
                this.listSearchText !== this.searchText ||
                this.listSelectedFilterItems !== JSON.stringify(this.filters.selectedFilterItems()) ||
                this.listSortName !== this.sortName) {

                this.listItemsChanged = false
                this.listSearchText = this.searchText
                this.listSelectedFilterItems = JSON.stringify(this.filters.selectedFilterItems())
                this.listSortName = this.sortName

                this._listItems = this.itemsMatchingSearch(this.items(), this.searchText)
                this._listItems = this.itemsMatchingFilters(this._listItems, this.filters)
                this._listItems = this.itemsSortedBy(this._listItems, this.sortName)

                this.filters.numResults = this._listItems.length
            }
        }
        return this._listItems
    }

    constructor(protected element: ElementRef,
                private resourcesProvider: ResourcesProvider,
                public resourcesCssService: ResourcesCssService,
                private windowService: WindowService,
                protected resourceStore: ResourceStore) {

        this.resources = this.resourceStore.getResources();
        this.resourceStore.state$
            .pipe(takeUntil(this.ngUnsubscribeResources))
            .subscribe(() => {
                this.resources = this.resourceStore.getResources();
            });
    }

    ngOnInit() {
        this.windowService.width$.subscribe((value: number) =>  this.resourcesCssService.width = value)

        const t = this
        // On slow computers (like old phones or iPads) it can take a long time to display a page.
        // The reason is that angular fully renders the page before displaying it. To speed up the
        // initial display of the page, we filter out all of the data until after the page
        // is displayed.
        navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
            const interval = setInterval(() => {
                const pageElement = document.querySelector(t.element.nativeElement.tagName + '.ion-page:not(.ion-page-invisible)') as Element
                if (pageElement) {
                    clearInterval(interval)

                    setTimeout(() => {
                        t.viewDisplayed = true

                        // TODO: Does this still need to be here
                        // DW 12/14/2023
                        t.updateFilters()
                        t.resourcesProvider.getResources().subscribe(resources => {
                            t.resources = resources
                            t.updateFilters()
                        })
                    }, 100)
                }
            }, 500)
        });
    }

    ngOnDestroy(){
        this.ngUnsubscribeResources.next(true);
        this.ngUnsubscribeResources.complete();
      }

    itemsTypes(items: T[]): string[] {
        const typesSet = new Set<string>()
        items.forEach( (item: T) => {
          this.itemTypes(item).forEach( (type: string) => typesSet.add(type.toLowerCase()) )
        })
        return Array.from(typesSet.values()).sort()
    }

    itemsMatchingSearch(items: T[], searchString: string): T[] {
        return items.filter( (item: T) => {
          return searchString.length === 0 || this.itemMatchesSearch(item, searchString)
        })
    }

    itemsSortedBy(items: T[], option: string) {
        return items
    }

    // This following methods are usually overridden by subclasses

    items(): T[] {
        return []
    }

    updateFilters() {
        this.listItemsChanged = true
    }

    itemsMatchingFilters(items: T[], filters: Filters): T[] {
        return items
    }

    itemMatchesSearch(item: T, searchString: string): boolean {
        return true
    }

    itemTypes(item: T): string[] {
        return []
    }

    trackByUuid(index: number, resource: Base): string {
        return resource.uuid
    }

}
